/* eslint-disable no-param-reassign,no-trailing-spaces,indent */
/**
 * Activation Services Controller file
 * @class
 */

class ActivationHourServicesController {
  /* @ngInject */
  constructor($scope, moment, $filter, $log) {
    const that = this;

    $scope.minDateMoment = moment().startOf('day');
    $scope.maxDateMoment = moment().endOf('day');

    $scope.weekdays = [
      {
        id: 1,
        name: $filter('translate')('common.date.monday'),
        enable: false,
        date: [], //[{from: '', to: '', seats: ''}]  //contains intervall
        error: false
      },
      {
        id: 2,
        name: $filter('translate')('common.date.tuesday'),
        enable: false,
        date: [], //[{from: '', to: '', seats: ''}]
        error: false
      },
      {
        id: 3,
        name: $filter('translate')('common.date.wednesday'),
        enable: false,
        date: [], //[{from: '', to: '', seats: ''}]
        error: false
      },
      {
        id: 4,
        name: $filter('translate')('common.date.thursday'),
        enable: false,
        date: [], //[{from: '', to: '', seats: ''}]
        error: false
      },
      {
        id: 5,
        name: $filter('translate')('common.date.friday'),
        enable: false,
        date: [],
        error: false//[{from: '', to: '', seats: ''}]
      },
      {
        id: 6,
        name: $filter('translate')('common.date.saturday'),
        enable: false,
        date: [],
        error: false //[{from: '', to: '', seats: ''}]
      },
      {
        id: 7,
        name: $filter('translate')('common.date.sunday'),
        enable: false,
        date: [],//[{from: '', to: '', seats: ''}]
        error: false
      },
    ];

    that.momentPickerHoursOptions = {
      minView: 'decade',
      maxView: 'minute',
      startView: 'hours',
      autoclose: true,
      today: false,
      keyboard: false,
      hoursFormat: 'HH',
      minutesFormat: moment.localeData().longDateFormat('LT').replace(/[aA]/, ''),
      secondsFormat: 'ss',
      minutesStep: 5
    };


    const daysNameConversionMapper = {
      'MONDAY': 0,
      'TUESDAY': 1,
      'WEDNESDAY': 2,
      'THURSDAY': 3,
      'FRIDAY': 4,
      'SATURDAY': 5,
      'SUNDAY': 6,
      1: 'MONDAY',
      2: 'TUESDAY',
      3: 'WEDNESDAY',
      4: 'THURSDAY',
      5: 'FRIDAY',
      6: 'SATURDAY',
      7: 'SUNDAY'
    };


    this.triggerToValue = (id, index, toOrFrom) => {
      let weekDaysIndex = id - 1;
      let value = $scope.weekdays[weekDaysIndex].date[index][toOrFrom];
      let modulus = value.getTime() % 900000;
      if (modulus !== 0) {
        let triggeredValue = value - modulus;
        $scope.weekdays[weekDaysIndex].date[index][toOrFrom] = new Date(triggeredValue);
      }
    };

    const openingHourCheck = (intervall) => {
      let checkFlag =
        (intervall.hasOwnProperty('from') && intervall.from !== '') &&
        (intervall.hasOwnProperty('to') && intervall.to !== '') &&
        (intervall.from.hasOwnProperty('hoursInMillis') && intervall.to !== '') &&
        (intervall.from.hasOwnProperty('minutesInMillis') && intervall.to !== '') &&
        (intervall.to.hasOwnProperty('hoursInMillis') && intervall.to !== '') &&
        (intervall.to.hasOwnProperty('minutesInMillis') && intervall.to !== '');

      return checkFlag;
    };

    const translateDaysForExporting = (days, prepareTime) => {
      let daysToExport = [];
      angular.forEach(days, (day) => {
        angular.forEach(day.date, (intervall) => {
            if (!openingHourCheck(intervall)) {
              return;
            }
            var date = $filter('date')(new Date(), 'yyyy-MM-dd');
            var minuteFrom = intervall.from.minutesInMillis != "00" ? intervall.from.minutesInMillis/(60*1000) : "00"
            var minuteTo = intervall.to.minutesInMillis != "00" ? intervall.to.minutesInMillis/(60*1000) : "00"
            if(minuteFrom == 1){minuteFrom = "01"}
            if(minuteTo == 1){minuteTo = "01"}
            var mOpeningTime = new Date(date+"T"+that.normalizeHour(intervall.from.hoursInMillis/(3600*1000)) +":"+ minuteFrom ).getTime()
            var mClosingTime = !this.office ? new Date(date+"T"+that.normalizeHour(intervall.to.hoursInMillis/(3600*1000)) +":"+ minuteTo).getTime() : prepareTime != undefined ? mOpeningTime + prepareTime*60*1000 : mOpeningTime
            let openingHoursBuffer =
              {
                dayOfWeek: daysNameConversionMapper[day.id],
                //openingTime: date+"T"+that.normalizeHour(intervall.from.hoursInMillis/(3600*1000)) +":"+ minuteFrom+":00.648+0100",
                //closingTime: date+"T"+that.normalizeHour(intervall.to.hoursInMillis/(3600*1000)) +":"+ minuteTo+":00.648+0100",
                openingTime: mOpeningTime,
                closingTime: mClosingTime,
                maxItems: 1000,
                enabled: day.enable,
                error: day.error
              };
            /*let openingHoursBuffer =
              {
                dayOfWeek: daysNameConversionMapper[day.id],
                openingTime: intervall.from.hoursInMillis + intervall.from.minutesInMillis,
                closingTime: intervall.to.hoursInMillis + intervall.to.minutesInMillis,
                maxItems: 1000,
              }*/
            daysToExport.push(openingHoursBuffer);
          }
        );
      });

      return daysToExport;
    };

    that.normalizeHour = (x)=>{

      return x.toString().padStart(2,'0');

    };

    that.range = (first, last, step, type) => {
      let cycleStep = step ? step : 1;
      let res = [];
      for (let i = 0; i <= last; i += cycleStep) {res.push(i)};
      if(type == "m"){
        res.push(1)
        res.push(59)
        res.sort((a,b) => {return a-b});
      }
      return res;
    };

    that.logValue = (x) => {

      $log.info('the value is : ' + x);

    };

    const setDays = (openingHours) => {

      angular.forEach(openingHours, (intervall) => {
        let dayIndex = daysNameConversionMapper[intervall.dayOfWeek];
        $scope.weekdays[dayIndex].enable = intervall.enabled;
        $scope.weekdays[dayIndex].date.push(
          {
            from: {
              hoursInMillis: new Date(Date.parse(intervall.openingTime)).getHours() * 3600 * Math.pow(10, 3),
              minutesInMillis: new Date(Date.parse(intervall.openingTime)).getMinutes() * 60 * Math.pow(10, 3)
            },
            to: {
              hoursInMillis: that.normalizeHour(new Date(Date.parse(intervall.closingTime)).getHours()) * 3600 * Math.pow(10, 3),
              minutesInMillis: new Date(Date.parse(intervall.closingTime)).getMinutes() * 60 * Math.pow(10, 3)
            },
            /*from: {
              hoursInMillis: (intervall.openingTime - (intervall.openingTime % (3600 * Math.pow(10, 3)))),
              minutesInMillis: (intervall.openingTime % (3600 * Math.pow(10, 3)))
            },
            to: {
              hoursInMillis: intervall.closingTime - ((intervall.closingTime % (3600 * Math.pow(10, 3)))),
              minutesInMillis: (intervall.closingTime % (3600 * Math.pow(10, 3)))
            },*/
            seats: intervall.maxItems
          }
        );
          console.log($scope.weekdays[dayIndex].date)
      });

    };

    const getDays = () => {
      return translateDaysForExporting($scope.weekdays, undefined);
    };

    const getDaysWithPrepareTime = (prepareTime) => {
      return translateDaysForExporting($scope.weekdays, prepareTime);
    }

    /*
    $scope.$watch('weekdays',
      (newValue, oldValue) => {
        if (angular.equals(newValue, oldValue)) return;
        this.exportedDays = translateDaysForExporting($scope.weekdays);
      }, true);
*/

    const enableDisableDay = (dayId) => {
      let dayObj = $scope.weekdays.find(item => item.id === dayId);
      if (dayObj.enable === true) {
        dayObj.enable = false;
      } else {
        dayObj.enable = true;
      }
      this.exportedDays = translateDaysForExporting($scope.weekdays);
    };
    $scope.enableDisableDay = enableDisableDay;

    const addTimeSlot = (dayId) => {
      const dayObj = $scope.weekdays.find(item => item.id === dayId);
      dayObj.date.push(
        {
          from: { hoursInMillis: 0, minutesInMillis: 0 },
          to: { hoursInMillis: 0, minutesInMillis: 0 },
          seats: ''
        }
      );
      this.exportedDays = translateDaysForExporting($scope.weekdays);
    };
    $scope.addTimeSlot = addTimeSlot;

    const deleteTimeSlot = (dayId, dateId) => {
      const dayObj = $scope.weekdays.find(item => item.id === dayId);
      dayObj.date.splice(dateId, 1);
      this.exportedDays = translateDaysForExporting($scope.weekdays);
    };
    $scope.deleteTimeSlot = deleteTimeSlot;


    const init = () => {
      this.setDays = setDays;
      this.getDays = getDays;
      this.getDaysWithPrepareTime = getDaysWithPrepareTime;
      console.log("office: "+this.office)
    };
    this.$onInit = init;

    $scope.checkDate = (day, data) => {
      if(data.to.hoursInMillis < data.from.hoursInMillis){
        day.error = true;
        return true;
      }else if(data.to.hoursInMillis == data.from.hoursInMillis && data.to.minutesInMillis < data.from.minutesInMillis){
        day.error = true;
        return true;
      }else{
        day.error = false;
        return false;
      }
    }

    $scope.save = () => {
      console.log($scope.weekdays);
    };
  }
}

export default ActivationHourServicesController;




/** WEBPACK FOOTER **
 ** ./client/app/common/components/activationHourServices/activationHourServices.controller.js
 **/